import { createAction, createSlice } from '@reduxjs/toolkit';
import { initialStore } from '../initial-store';
import { IState } from 'shared/interfaces/state.interface';

export const getAvailablePharmacies = createAction(
  'pharmacies/GET_AVAILABLE_PHARMACIES',
  (payload) => ({ payload })
);

export const setPharmacy = createAction(
  'pharmacies/SET_PHARMACY',
  (payload) => ({ payload })
);
// Slices

const pharmaciesSlice = createSlice({
  name: 'pharmacies',
  initialState: initialStore.pharmacies,
  reducers: {
    setAvailablePharmaciesLoading: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setAvailablePharmacies: (state, { payload }) => {
      state.isLoading = false;
      state.availablePharmacies = payload;
    },
    getAvailablePharmaciesFail: (state) => {
      state.isLoading = false;
    },
    resetAvailablePharmacies: (state) => {
      state.availablePharmacies = [];
    }
  }
});

export const {
  setAvailablePharmaciesLoading,
  setAvailablePharmacies,
  getAvailablePharmaciesFail,
  resetAvailablePharmacies
} = pharmaciesSlice.actions;

export const { reducer } = pharmaciesSlice;

// Selectors
export const pharmaciesLoadingSelector = (state: IState) =>
  state && state.pharmacies.isLoading;

export const getAvailablePharmaciesSelector = (state: IState) =>
  state && state.pharmacies.availablePharmacies;
